import {Input, RenderWYSIWYG} from 'Components/Form';
import Auth from 'Components/Layouts/Auth';
import CmsElement from 'Components/Utilities/CmsElement';
import React from 'react';
import {Loading} from 'Components/Partials';
import { asset } from 'Services/BaseHelpers';
import { getRecordValue } from 'Services/CmsHelpers';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class Accommodation extends CmsElement {
    /**
     * @constructor
     */
    constructor(props) {
        super(props);
    }

    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'accommodation';

    /**
     * @var state
     */
    state = {
        params: {
            element: 'accommodation',
            paginate: false,
            search: '',
        },
        content: null,
        working: true,
    };

    header = () => (
        <div className="h-banner bg-app-blue relative flex flex-row w-full">
                <div className={"w-0 lg:w-1/2"}>
                    <img alt=""
                         src={asset('/images/pages/faq/lobby.png')}
                         className="hidden lg:block h-banner w-full"
                    />
                </div>

                <div className={"w-full lg:w-1/2 self-center lg:self-end"}>
                    <div
                        className="block lg:hidden text-center align-center font-gilroy text-app-green-banner-light text-4xl"
                    >
                        Accom
                        <span className={"text-white"}>
                            modation
                        </span>
                    </div>
                    <div className=" h-full w-full relative  align-bottom text-8xl flex flex-row">

                        <div
                            style={{
                                writingMode:  'vertical-rl'
                         }}
                            className="hidden lg:block align-text-bottom align-bottom font-gilroy text-app-green-banner-light -ml-16 mb-5">
                                Accom
                        </div>
                        <div
                            className="hidden lg:block align-text-bottom align-bottom font-gilroy -ml-3 -bottom-0 text-white self-end mb-5">
                            modation
                        </div>
                    </div>
                    <img alt="" src={asset('/images/logo-white.png')}
                         className="max-h-banner absolute right-5 m-5 top-0 block w-32"
                    />
                </div>
        </div>
    );

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {working, records} = this.state;

        return (
            <Auth customHeader={this.header()} containerWidth="" containerPadding={"0"}>
                <div className={"bg-app-dark-gray text-xl p-10 text-white text-center font-gilroy absolute -left-0 right-0 -mt-5"}>
                    Date: Wednesday 25th October 2023 at 3pm
                </div>

                <div className={"text-7xl text-red-600 text-center font-gilroy"}>
                    Accommodation
                </div>

                {!working && records.data.filter(i => getRecordValue(i, 'type') === 'branded').length > 0 && (
                    <div className={"mt-40 lg: mt-0 text-2xl: md:text-9xl text-center text-app-blue font-gilroy"}>
                        Branded
                    </div>
                )}
                <div className="p-4 text-center clear-both">
                    <div className="mx-auto mb-56">
                        {/*<div className="max-w-7xl mx-auto">*/}
                        {/*    <div className="relative w-full md:w-3/4 lg:w-1/2 mx-auto">*/}
                        {/*        {this.renderSearchBar()}*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {working && <Loading/>}

                        {!working &&
                        <div className="relative z-10 mb-48 -mx-6 sm:-mx-8 lg:-mx-12">
                            <div className="max-w-7xl mx-auto">
                                <div className="w-full mx-auto grid grid-cols-1 lg:grid-cols-2 gap-20 border-1 border-white mb-10">
                                    {records.data !== null && (!records.data || records.data.length === 0) && (
                                        <p className="text-center my-4">
                                            There are no items to show you.
                                        </p>
                                    )}

                                    { records.data.filter(i => getRecordValue(i, 'type') === 'branded').map(item => (
                                        this.renderItemBody(item, 0)
                                    ))}
                                </div>
                            </div>
                        </div>
                        }

                        {!working &&
                            <div className="bg-app-dark-gray w-full absolute left-0 right-0 clear-both ">
                                {!working && records.data.filter(i => getRecordValue(i, 'type') === 'boutique').length > 0 && (
                                    <div className={"text-2xl md:text-9xl text-center text-app-red -mt-12 lg:-mt-20 mb-15  font-gilroy"}>
                                        Boutique
                                    </div>
                                )}
                                <div className="max-w-7xl mx-auto">
                                    <div className="w-full mx-auto grid grid-cols-1 lg:grid-cols-2 gap-20 border-1 border-white mb-10">
                                        { records.data.filter(i => getRecordValue(i, 'type') === 'boutique').map(item => (
                                            this.renderItemBody(item, 0)
                                        ))}
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="text-center">
                            If your question isn’t answered in the above please contact us
                            at <a className="text-app-red" href="mailto:info@speedolaunch.com">info@speedolaunch.com</a>
                        </div>
                    </div>
                </div>
            </Auth>
        );
    }

    toggleQuestion = (itemKey) => {
        const {records} = this.state;
        records.data[itemKey].open = !records.data[itemKey].open;

        this.setState({
            records,
        });
    }

    setElementHeight = (el) => {
        if (el !== null) {
            el.style.setProperty('--max-height', el.children[0].clientHeight + 'px');
        }
    }

    /**
     * @method renderItemBody
     * @param {object} item
     * @param {string} item.question
     * @param {string} item.answer
     * @param {string} item.link
     * @param {bool} item.open
     * @param {number} k
     * @return {JSX.Element}
     */
    renderItemBody = (item, k) => {
        const btnClass = `${item.open ? '-rotate-180' : 'rotate-0'} h-6 w-6 transform m-auto`;
        const ansClass = `${item.open ? 'max-h-var' : 'max-h-0'} px-4 sm:px-12 overflow-hidden transition-all duration-500`;

        const name = getRecordValue(item, 'name');
        const address = getRecordValue(item, 'address');
        const details = getRecordValue(item, 'details');
        const link = getRecordValue(item, 'link');
        const thumbnail = getRecordValue(item, 'thumbnail', 'file');
        const type = getRecordValue(item, 'type');

        return (
            <div key={k} className={
                'h-full w-full p-10 mb-6 font-gilroy'
            }>
                <div className={`text-lg space-y-5
                        ${type == 'branded' ? 'text-app-gray-dark' : 'text-white'}`
                }>
                    {address && <button type="button" aria-controls="faq-0" aria-expanded="false"
                            onClick={() => this.toggleQuestion(k)} className={
                        'text-left w-full flex flex-col justify-between items-start text-gray-400  py-2 space-y-5'
                    }>
                        <div className="block w-full font-gilroy font-bold w-full text-gray-900">
                            <img src={thumbnail}  className={"mx-auto rounded-3xl"}/>
                        </div>

                        <div
                            className={`
                                block w-full font-gilroy w-full text-4xl font-bold"
                                ${type == 'branded' ? 'text-app-blue' : 'text-app-red'}
                            `}
                        >

                            {name}
                        </div>
                    </button>}

                    {link && <a  href={link} target="_blank" className={
                        'font-gilroy text-left w-full flex justify-between items-start text-gray-400 px-4 py-2'
                    }>

                        <span
                            className={`
                                font-gilroy font-bold"
                                ${type == 'branded' ? 'text-app-blue' : 'text-app-red'}
                            `}
                        >
                            {name}
                        </span>
                    </a>}
                    <div>
                        <RenderWYSIWYG content={address} className={"font-gilroy"} />
                    </div>
                    <div>
                        <RenderWYSIWYG content={details} className={"font-gilroy"} />
                    </div>
                </div>
            </div>
        );
    }
}
